import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LayoutIcon from '../../../assets/icons/svg/stamp-icons/ic-stamp-add-money.svg';
import SendMoneyIcon from '../../../assets/icons/svg/colored-icons/ic-colored-expense-transparent.svg';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import {
  IDS, TEXT, STYLE, LINKS,
} from '../constants';
import { useGenerateLinkToken } from '../../../hooks/query/useGenerateLinkToken';
import { useStore } from '../../../store';
import { PlaidActionWrapper } from './PlaidActionWrapper';
import { IPostLinkData } from '../../../types';
import { FlowContext } from '../pages';
import { trackMixPanel } from '../../../services/mixpanel.service';

const { PAGES: { GET_STARTED } } = STYLE;

const { PAGES: { GET_STARTED: GET_STARTED_TEXT } } = TEXT;

const { PAGES: { GET_STARTED: GET_STARTED_IDS } } = IDS;

interface IProps {
    handlePlaidMetaData: (data: IPostLinkData) => void;
    isFetchingLinkedAccounts: boolean;
}

export const GetStarted = ({ handlePlaidMetaData, isFetchingLinkedAccounts }: IProps) => {
  const [linkToken, setLinkToken] = useState<string>('');
  const { customerId } = useStore(state => state.user);
  const { t } = useTranslation();
  const isAddMoneyFlow = useContext(FlowContext);
  const { refetch: fetchLinkToken, isLoading, isRefetching } = useGenerateLinkToken(customerId);
  const handlePostLink = (data: IPostLinkData) => {
    setLinkToken('');
    handlePlaidMetaData(data);
  };
  const handleGenerateToken = () => {
    trackMixPanel('Act on Plaid Intro Screen', { Action: 'Lets Start' });
    fetchLinkToken()
      .then(({ data }) => {
        const { linkToken: { link_token: linkTokenRes } } = data;
        setLinkToken(linkTokenRes);
      });
  };

  const handleSupportedBanks = () => {
    window.open(LINKS.SUPPORTED_BANKS, '_blank');
  };

  return (
    <>
      <img id='add-money-icon' className={GET_STARTED.HEADING_IMAGE} src={isAddMoneyFlow ? LayoutIcon : SendMoneyIcon} alt='Add Money' />
      <Heading title={isAddMoneyFlow ? t(GET_STARTED_TEXT.HEADING) : t(GET_STARTED_TEXT.HEADING_SEND_MONEY)} className={GET_STARTED.HEADING} />
      <p id='get-started-subheader' className={GET_STARTED.CONTENT}>
        {isAddMoneyFlow ? t(GET_STARTED_TEXT.CONTENT) : t(GET_STARTED_TEXT.CONTENT_SEND_MONEY) }
      </p>
      <Button
        className=''
        id={GET_STARTED_IDS.SUPPORTED_BANKS_CTA}
        childElement={(
          <div data-testid='supportedBanksCTA' tabIndex={0} role='button' onKeyDown={() => {}} onClick={handleSupportedBanks} className={GET_STARTED.SUPPORTED_BANKS_CTA.CHILD.CONTAINER}>
            <Heading testId='supportedBanks' title={t(GET_STARTED_TEXT.SUPPORTED_BANKS_CTA.CHILD.HEADING)} className={GET_STARTED.SUPPORTED_BANKS_CTA.CHILD.HEADING} />
            <ArrowIcon id='arrow-right-icon' className={GET_STARTED.SUPPORTED_BANKS_CTA.CHILD.ICON} />
          </div>
                )}
      />
      <PlaidActionWrapper shouldAutoOpenLink linkStyle={GET_STARTED.PLAID_CTA} linkTitle={t(GET_STARTED_TEXT.PLAID_CTA)} linkToken={linkToken} isLoading={isLoading || isFetchingLinkedAccounts || isRefetching} isFetchLinkToken={isLoading || isRefetching} callbackHandler={handleGenerateToken} handlePostLink={handlePostLink} />
    </>
  );
};
